<form class="data-wrap" fxLayout="column" [formGroup]="form">
    <div class="title" fxLayoutGap="5px" fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-icon>format_list_bulleted</mat-icon><span i18n>Save current route</span>
    </div>

    <div class="desc" i18n>
        Save your current route to be quickly accessible from the main menu or the favorite menu.
    </div>

    <app-user-setting-input
        type="text"
        i18n-placeholder
        [placeholder]="'Enter a name for the route'"
        [control]="form.get('label') | cast"
    >
        <label role="input-label" fxLayoutGap="4px">
            <span i18n>Name</span>
        </label>
    </app-user-setting-input>
    <app-customer-chip-select
        *ngIf="navData.data.user.isMasterAdmin()"
        (onUpdateCustomers)="onUpdateCustomer($event)"
        class="w-100"
        titleLabel="Academy"
        i18n-titleLabel
        [formControl]="customer_ids"
    ></app-customer-chip-select>
    <div *ngIf="navData.data.user.isAdmin()" fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="start start">
        <span class="context" i18n>Create for</span>
        <div fxLayout="row" fxLayoutGap="20px">
            <mat-radio-group [formControl]="context" class="course-sett-not" fxLayout="row" fxLayoutGap="10px">
                <mat-radio-button value="user" i18n>Me</mat-radio-button>
                <mat-radio-button value="customer" i18n>Academy</mat-radio-button>
                <mat-radio-button value="specify" i18n>Specify</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <div *ngIf="context.value === 'customer'" fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="start start">
        <div fxLayout="column" fxLayoutGap="20px">
            <div [formGroup]="rolesFormGroup" fxLayout="column" fxLayoutGap="8px">
                <label i18n class="roles-label">Select roles who can access this route:</label>
                <div fxLayout="column" fxLayoutGap="5px" class="roles-checkbox-group">
                    <ng-container *ngFor="let role of allUserRoles">
                        <mat-checkbox [formControlName]="role.value">{{ role.label }}</mat-checkbox>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <app-user-setting-input
        type="text"
        i18n-placeholder
        [placeholder]="'Enter the route of the link'"
        [control]="form.get('route') | cast"
    >
        <label role="input-label" fxLayoutGap="4px">
            <span i18n>Route</span>
        </label>
    </app-user-setting-input>
    <mat-checkbox formControlName="navbar" [disabled]="!navData.data.availableNavbar">
        <div
            fxLayout="row"
            fxLayoutGap="5px"
            class="roles-checkbox-group"
            [ngClass]="{ muted: !navData.data.availableNavbar }"
        >
            <mat-icon>format_list_bulleted</mat-icon>
            <span i18n>Appears in the main menu</span>
            <mat-icon
                *ngIf="!navData.data.availableNavbar"
                class="error-icon"
                matTooltip="You have reached the maximum number of navbar links"
                >error_outline</mat-icon
            >
        </div>
    </mat-checkbox>
    <mat-checkbox formControlName="favorite" [disabled]="!navData.data.availableFavorites">
        <div
            fxLayout="row"
            fxLayoutGap="5px"
            class="roles-checkbox-group"
            [ngClass]="{ muted: !navData.data.availableFavorites }"
        >
            <mat-icon>star</mat-icon>
            <span i18n>Appears in the favorite menu</span>
            <mat-icon
                *ngIf="!navData.data.availableFavorites"
                class="error-icon"
                matTooltip="You have reached the maximum number of favorite links"
                >error_outline</mat-icon
            >
        </div>
    </mat-checkbox>

    <!-- <mat-radio-group [formControl]="favouriteType" class="course-sett-not" fxLayout="column" fxLayoutGap="10px">
        <mat-radio-button [disabled]="!navData.data.availableNavbar" value="navbar">
            <mat-icon>format_list_bulleted</mat-icon>
            <span i18n>Appears in the main menu</span>
            <mat-icon
                *ngIf="!navData.data.availableNavbar"
                class="error-icon"
                matTooltip="You have reached the maximum number of navbar links"
                >error_outline</mat-icon
            >
        </mat-radio-button>
        <mat-radio-button [disabled]="!navData.data.availableFavorites" value="favorite">
            <mat-icon>star</mat-icon>
            <span i18n>Appears in the favorite menu</span>
            <mat-icon
                *ngIf="!navData.data.availableFavorites"
                class="error-icon"
                matTooltip="You have reached the maximum number of favorite links"
                >error_outline</mat-icon
            >
        </mat-radio-button>
    </mat-radio-group> -->

    <div class="action">
        <button
            [disabled]="!form.valid || (context.value !== 'user' && !customer)"
            fxFlex="0 0 auto"
            class="mobile-button"
            (click)="submit()"
            mat-raised-button
            type="button"
        >
            <span>Done</span>
        </button>
    </div>
</form>
